const KEY_CONFIG_COLUMN = "column_seting_show_hidden";

const readColumnsSettings = (): Record<string, any> => {
  try {
    const stored = localStorage.getItem(KEY_CONFIG_COLUMN);
    const parsed = stored ? JSON.parse(stored) : {};
    return parsed && typeof parsed === "object" && !Array.isArray(parsed)
      ? parsed
      : {};
  } catch {
    return {};
  }
};

export const handleSetColumnsSettings = (key: string, data: any) => {
  if (typeof localStorage === "undefined") return;

  localStorage.setItem(
    KEY_CONFIG_COLUMN,
    JSON.stringify({ ...readColumnsSettings(), [key]: data }),
  );
};

export const handleGetColumnsSettings = (key: string) => {
  const settings = readColumnsSettings();
  return Object.prototype.hasOwnProperty.call(settings, key)
    ? settings[key]
    : undefined;
};
